<template>
    <div class="selector" @focusout="onFocusOut" ref="wrap">
        <div class="search">
            <input type="search" v-model="searchText" @keydown="doKeyboard($event, false)" ref="search" role="searchbox"
            :aria-label="$t('moveSelector.ariaSearchBox')">
        </div>
        <div class="options" @keydown="doKeyboard($event, false)">
            <b-checkbox type="checkbox" v-model="copyMode" switch aria-keyshortcuts="Alt+c" role="switch"
                :disabled="rights.indexOf('t') === -1">
                {{$t('moveSelector.copyMode')}}
            </b-checkbox>
        </div>
        <div class="folderlist" tabindex="0" @keydown="doKeyboard($event, true)" role="listbox"
                :aria-label="$t('moveSelector.ariaFolderList')">
            <div v-for="(f,ind) in filteredFolderTree" :key="ind" :ref="`fld-${ind}`"
                :class="{ disabled: f.disabled, selected: ind === selectIndex }" class="item"
                @mouseenter="mouseSelect(ind)" @click="clickEntry(ind)" role="option"
                :aria-selected="ind === selectIndex">
                <span v-if="f.indent===-1">
                    <span v-if="f.parent!==''">{{f.parent}}/</span>
                    <span class="searchHighlight">{{f.text.substr(0, searchText.length)}}</span>
                    <span>{{f.text.substr(searchText.length)}}</span>
                </span>
                <span v-else :style="`padding-left:${f.indent}px`">
                    {{f.text}}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import FolderSorter from '../helpers/folderSorting';

export default {
  name: 'moveSelector',
  data: function() {
    return {
      levelPadding: 10,
      selectIndex: 0,
      searchText: '',
      copyMode: this.rights.indexOf('t') === -1
    };
  },
  props: {
    rights: String
  },
  mounted() {
    this.$nextTick(() => this.$refs.search.focus());
    console.log('move Selector mounted - rights', this.rights);
  },
  methods: {
    mouseSelect(ind) {
      if (!this.filteredFolderTree[ind].disabled) {
        this.selectIndex = ind;
      }
    },
    clickedOutside() {
      // console.log('clicked outside event');
      // this.$emit('hide');
    },
    onFocusOut(evt) {
      console.log(evt.relatedTarget, this.$refs);
      console.log('moveselector blur');
      if (!this.$refs.wrap.contains(evt.relatedTarget)) {
        this.$emit('hide');
      }
    },
    doKeyboard(evt, listbox) {
      const oldSelect = this.selectIndex;
      if (evt.key === 'ArrowDown') {
        this.selectIndex++;
        evt.preventDefault();
      } else if (evt.key === 'ArrowUp') {
        this.selectIndex--;
        evt.preventDefault();
      } else if (evt.key === 'PageDown') {
        this.selectIndex += 10;
      } else if (evt.key === 'PageUp') {
        this.selectIndex -= 10;
      } else if ((evt.key === 'Home') && listbox) {
        this.selectIndex = 0;
      } else if ((evt.key === 'End') && listbox) {
        this.selectIndex = this.filteredFolderTree.length - 1;
      } else if (evt.key === 'Escape') {
        this.$emit('hide');
      } else if (evt.key === 'c' && evt.altKey) {
        this.copyMode = !this.copyMode;
      } else if (((evt.key === 'Enter') || ((evt.key === 'Space') && listbox)) && (this.selectIndex >= 0) &&
        (this.selectIndex < this.filteredFolderTree.length)) {
        this.$emit('select', { targetFolder: this.filteredFolderTree[this.selectIndex], copy: this.copyMode });
      }
      if (this.selectIndex >= this.filteredFolderTree.length) {
        this.selectIndex = this.filteredFolderTree.length - 1;
      }
      if (this.selectIndex < 0) {
        this.selectIndex = 0;
      }
      evt.stopPropagation();

      if ((oldSelect !== this.selectIndex) && (this.filteredFolderTree.length > 0)) {
        this.$refs[`fld-${this.selectIndex}`][0].scrollIntoView({ behaviour: 'smooth', block: 'nearest' });
      }
    },
    clickEntry(ind) {
      this.$emit('select', { targetFolder: this.filteredFolderTree[ind], copy: this.copyMode });
    },
    getSortedTree(folder, result, indent) {
      if ((folder.id === -1) || (folder.id === -2)) {
        return;
      }
      if (indent >= 0) {
        result.push({ text: `${folder.dispName}`,
          value: folder.name,
          indent,
          disabled: folder.rights.indexOf('i') === -1,
          parent: folder.parent,
          id: folder.id
        });
      }
      if (Object.keys(folder.children).length > 0) {
        for (let name of FolderSorter(folder.children, folder.parent === null)) {
          this.getSortedTree(folder.children[name], result, indent + this.levelPadding);
        }
      }
      return result;
    }
  },
  computed: {
    folderTree() {
      return this.getSortedTree(this.$store.state.folders, [], -this.levelPadding);
    },
    filteredFolderTree() {
      if (this.searchText === '') {
        return this.folderTree;
      } else {
        const len = this.searchText.length;
        return this.folderTree.filter(f => f.text.substr(0, len).localeCompare(this.searchText, undefined,
          { sensitivity: 'base' }) === 0)
          .map(f => {
            f.indent = -1;
            return f;
          });
      }
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';
    .selector {
        display: inline-block;
        z-index: 100;
        position: absolute;
        top: 20px;
        left: 0px;
        background-color: white;
        color: $black;
        box-shadow: 0px 0px 5px 3px $gray-200;
        max-height: 50vh;
        min-height: 50px;
        width:50vh;
        padding: 0;
        display: flex;
        flex-direction: column;

        .search {
            flex: 0 0 20px;
            padding: 5px;
            input {
                width: calc(100% - 10px);
                padding: 10px;
                border-radius: 3px;
                border: 1px solid $gray-200;
                //border-bottom: 2px solid black;
            }
        }

        .options {
            flex: 0 0 20px;
            padding: 0 5px;
            border-bottom: 1px solid $gray-200;
        }

        .folderlist {
            flex: 1;
            overflow-y: scroll;
            overflow-x: auto;

            .item {
                padding: 5px 5px 5px 5px;
                cursor: pointer;
                user-select: none;
                &.selected {
                    background-color: $generic-select-background;
                }
                &.disabled {
                    color: $gray-500;
                    cursor: inherit;
                }
                .searchHighlight {
                    font-weight: bold;
                }
            }
        }
    }

</style>
